import OAuth2AuthProvider from '~/config/auth/OAuth2AuthProvider';
import { authRequestFn, tokenRefreshFn } from '~/config/auth/api';

export default (host: string) =>
  new OAuth2AuthProvider({
    authRequestFn: authRequestFn(host),
    tokenRefreshFn: tokenRefreshFn(host),
  });
